import { Entity, schema } from '@data-client/rest';
import { EncryptionAttachmentEntity } from './EncryptionAttachment';
import { EncryptionRestrictionEntity } from './EncryptionRestriction';
import { EncryptionUserEntity } from './EncryptionUser';
import { ISODate } from '../utils/transforms';
class EncryptionEntity extends Entity {
    constructor() {
        super(...arguments);
        this.attachments = null;
        this.attachmentsCount = 0;
        this.authorEmail = null;
        this.authorizedUserCount = 0;
        this.authorizedUsers = null;
        this.companyName = null;
        this.creationDTTM = new Date(0);
        this.drm = null;
        this.enableDecryptReceipts = false;
        this.encryptionGUID = null;
        this.encryptionId = 0;
        this.encryptionRestriction = null;
        this.fileName = null;
        this.notesIncluded = false;
        this.organizationId = 0;
        this.status = null;
        this.statusDTTM = new Date(0);
        this.totalSize = null;
        this.userId = null;
    }
    pk() {
        return this.encryptionGUID || this.encryptionId.toString();
    }
}
EncryptionEntity.schema = {
    attachments: new schema.Collection([EncryptionAttachmentEntity]),
    authorizedUsers: new schema.Collection([EncryptionUserEntity]),
    creationDTTM: ISODate,
    encryptionRestriction: EncryptionRestrictionEntity
};
EncryptionEntity.key = 'Encryption';
export { EncryptionEntity };
